import { render } from "./BoundLocalProductsList.vue?vue&type=template&id=74cba029&scoped=true"
import script from "./BoundLocalProductsList.vue?vue&type=script&lang=js"
export * from "./BoundLocalProductsList.vue?vue&type=script&lang=js"

import "./BoundLocalProductsList.vue?vue&type=style&index=0&id=74cba029&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cba029"]])

export default __exports__